import { render, staticRenderFns } from "./totpverify.vue?vue&type=template&id=330370df&scoped=true"
import script from "./totpverify.vue?vue&type=script&lang=js"
export * from "./totpverify.vue?vue&type=script&lang=js"
import style0 from "./totpverify.vue?vue&type=style&index=0&id=330370df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330370df",
  null
  
)

export default component.exports